<template>
  <div class="wm-wrap">
    <slot></slot>
    <div v-if="showWatermark" class="wm-layer" :style="watermarkStyle"></div>
  </div>
</template>

<script>
const SHOW_WATERMARK = false; // 設為 false 可關閉全站浮水印

export default {
  name: 'WatermarkImage',
  computed: {
    showWatermark() {
      return SHOW_WATERMARK;
    },
    watermarkText() {
      const org = this.$store.state.myOrganization;
      const user = this.$store.state.userData;
      return (org && org.email) || (org && org.name) || (user && user.email) || (user && user.name) || '';
    },
    watermarkStyle() {
      const text = encodeURIComponent(this.watermarkText);
      const svg = `%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='38' overflow='visible'%3E%3Ctext x='4' y='26' font-size='13' font-weight='600' fill='rgba(232,145,0,0.20)' font-family='sans-serif' letter-spacing='1'%3E${text}%3C/text%3E%3C/svg%3E`;
      return {
        backgroundImage: `url("data:image/svg+xml,${svg}")`,
      };
    },
  },
};
</script>

<style scoped>
.wm-wrap {
  position: relative;
  overflow: hidden;
}
.wm-layer {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  transform: rotate(-30deg);
  pointer-events: none;
  user-select: none;
  background-repeat: repeat;
  z-index: 1;
}
</style>
